import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';

import './ww-element.scss';

interface IProps {
  element: string;
  notext?: boolean;
}

export const WWElement: React.FC<IProps> = ({ element, notext }) => {
  const popoverElement = (
    <Popover id="popover-element">
      <Popover.Header as="h3">{element}</Popover.Header>
      <Popover.Body>
        {element} is one of the elements available in Honkai: Star Rail.
      </Popover.Body>
    </Popover>
  );
  return (
    <OverlayTrigger
      trigger="click"
      rootClose
      placement="auto-start"
      overlay={popoverElement}
    >
      <div className={`ww-element ${element}`}>
        {element === 'Aero' && (
          <>
            <StaticImage
              src="../../../../images/ww/icons/element_aero.png"
              alt={element}
            />
          </>
        )}
        {element === 'Electro' && (
          <>
            <StaticImage
              src="../../../../images/ww/icons/element_electro.png"
              alt={element}
            />
          </>
        )}
        {element === 'Fusion' && (
          <>
            <StaticImage
              src="../../../../images/ww/icons/element_fusion.png"
              alt={element}
            />
          </>
        )}
        {element === 'Glacio' && (
          <>
            <StaticImage
              src="../../../../images/ww/icons/element_glacio.png"
              alt={element}
            />
          </>
        )}
        {element === 'Havoc' && (
          <>
            <StaticImage
              src="../../../../images/ww/icons/element_havoc.png"
              alt={element}
            />
          </>
        )}
        {element === 'Spectro' && (
          <>
            <StaticImage
              src="../../../../images/ww/icons/element_spectro.png"
              alt={element}
            />
          </>
        )}
        {notext ? <></> : <span>{element}</span>}
      </div>
    </OverlayTrigger>
  );
};
